import { DayPilot } from "daypilot-pro-angular";


export class ResourceBase implements DayPilot.ResourceData {

  constructor(
    public id: string,
    public isGroup: boolean,
    public type: string,
    public moveDisabled: boolean,
    public html: string,
    public name: string,
    public toolTip?: string) {
  }

  public static castToResourceBase(args: DayPilot.ResourceData): ResourceBase {
    return args as ResourceBase;
  }
}



